<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-xl-12">
          <div class="row">
            <div class="messages-container margin-top-0" style="width: 100%">
              <div class="messages-container-inner">
                <!-- Message Field and search -->
                <div v-loading="loading" class="messages-inbox" id="messageField"
                     v-if="newMessageField == false">
                  <div class="messages-headline">
                    <div class="row">
                      <div class="col-6">
                        <img :src="this.getUserModel.avatar" alt=""
                             style="height: 40px;width:40px;border-radius: 50px;object-fit: contain;">
                      </div>
                      <div class="col-6">
                        <button class="btn" style="float: right;font-size: 25px;color: grey;"
                                v-on:click="openNewMessageField">
                          <span><i class="ni ni-fat-add"></i></span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div style="padding: 1px">
                    <input type="text" class="form-control" v-model="searchQuery"
                           placeholder="Ara" @keyup="submitSearch('chat')"
                           style="margin: 9px 0px 10px 0px; border-radius: 6px">
                  </div>
                  <!--                            <button v-on:click="submitSearch">Ara</button>-->
                  <ul>
                    <li v-for="item in conversations" :key="item.id">
                      <!--      normal two users messages field -->
                      <a v-if="item.is_group == 0"
                         :class="item.last_message.sender_id != getUserModel.id && item.last_message.seen == 0 ? 'unread' : 'read'"
                         @click="conversationDetail(item,'conversation')">
                        <div class="message-avatar"><img
                            :src="item.conversation_users[0].user_id == getUserModel.id ? item.conversation_users[1].user.avatar : item.conversation_users[0].user.avatar"
                            alt=""></div>
                        <div class="message-by">
                          <div class="message-by-headline">
                            <h5>{{
                                item.conversation_users[0].user_id == getUserModel.id ?
                                    item.conversation_users[1].user.name :
                                    item.conversation_users[0].user.name
                              }}</h5>
                            <p style="font-size:10px">{{ item.last_message.left_time }}</p>
                          </div>
                          <p>{{ item.last_message.message }}</p>
                          <div v-if="conversation !== null && item.id == conversation.id">
                            <span class="active-chat-item"></span>
                          </div>
                          <div v-if="item.last_message.sender_id != getUserModel.id && item.last_message.seen == 0">
                            <span class="notify-ring">{{ item.conversation_messages_count }}</span>
                          </div>
                        </div>
                      </a>
                      <!--      normal two users messages field end -->
                      <!--  group message field-->
                      <a v-else
                         :class="item.last_message.sender_id != getUserModel.id && item.last_message.seen == 0 ? 'unread' : 'read'"
                         @click="conversationDetail(item,'conversation')">
                        <div class="message-avatar">
                          <img
                              :src="getUserModel.avatar"
                              alt="">
                        </div>
                        <div class="message-by">
                          <div class="message-by-headline">
                            <h5>{{
                                item.title
                              }}</h5>
                            <p style="font-size:10px">{{ item.last_message.left_time }}</p>
                          </div>
                          <p>{{ item.last_message.message }}</p>
                          <div v-if="conversation !== null && item.id == conversation.id">
                            <span class="active-chat-item"></span>
                          </div>
                          <div v-if="item.last_message.sender_id != getUserModel.id && item.last_message.seen == 0">
                            <span class="notify-ring">{{ item.conversation_messages_count }}</span>
                          </div>
                        </div>
                      </a>
                      <!--group message field end-->
                    </li>
                    <!-- empty message field -->
                    <li v-if="this.conversations == ''">
                      <a>
                        <div class="message-by">
                          <p>Henüz bir mesajınız yoktur.</p>
                        </div>
                      </a>
                    </li>
                    <!-- empty message field -->
                    <infinite-loading spinner="circles" direction="bottom"
                                      @infinite="conversationsLoadMore"></infinite-loading>
                  </ul>
                </div>
                <!-- Message Field and search / end -->
                <!-- New Message Field and connection search -->
                <div v-loading="loading" v-else>
                  <div class="messages-inbox" id="newMessageField" v-if="jobStatusTypeField == false">
                    <div class="messages-headline">
                      <div class="row" style="align-items: center;">
                        <div class="col-3">
                                        <span style="font-size:20px;" v-on:click="closeNewMessageBox"><i
                                            class="ni ni-bold-left"></i></span>
                        </div>
                        <div class="col-9">
                          <button class="btn" style="float: right;color: grey;">İlan Seçiniz</button>
                        </div>
                      </div>
                    </div>
                    <div style="padding: 2px">
                      <input type="text" class="form-control" ref="searchField" v-model="jobSearchText"
                             placeholder="Ara" @keyup="searchJobs()"
                             style="margin: 9px 0px 10px 0px; border-radius: 2px">
                    </div>

                    <ul>
                      <li v-for="item in results" :key="item.id" class="">
                        <div style="padding: 12px;cursor: pointer" @click="openJobStatusTypeField(item.id)">
                          <div
                              style="display: flex;flex-direction: row;justify-content: space-between;margin: 0 4px 0 4px;align-items: center;padding: 2px">
                            <div>
                              <span style="font-size: 12px;font-weight: bold">{{ item.title }}</span>
                            </div>
                            <!--                            <div style="padding-right: 15px;">-->
                            <!--                              <span style="font-size: 11px;">{{ item.type.name }}</span>-->
                            <!--                            </div>-->
                          </div>
                        </div>
                      </li>
                      <infinite-loading v-if="conversations !== '' || conversations !== null" spinner="circles"
                                        direction="bottom"
                                        @infinite="jobsLoadMore"></infinite-loading>
                    </ul>
                  </div>
                  <div class="messages-inbox" id="jobStatusTypeField" v-else>
                    <div class="messages-headline">
                      <div class="row" style="align-items: center;">
                        <div class="col-3">
                                        <span style="font-size:20px;" v-on:click="closeJobStatusTypeField"><i
                                            class="ni ni-bold-left"></i></span>
                        </div>
                        <div class="col-9">
                          <button class="btn" style="float: right;color: grey;">İlan Aşamaları</button>
                        </div>
                      </div>
                    </div>
                    <el-form :model="groupForm" :rules="rules" ref="groupForm">
                      <div style="padding: 10px">
                        <h5>Grup oluştur</h5>

                        <el-radio-group v-model="groupForm.job_select_type" @change="changeJobSelection" size="mini">
                          <!--                          <el-radio-button label="1" style="width: 100%;padding: 10px">İlana Başvuran Tüm Kişileri-->
                          <!--                            Ekle-->
                          <!--                          </el-radio-button>-->
                          <el-radio-button label="2" style="width: 100%;padding: 10px;">İlan Sonuçlarına Göre Ekle
                          </el-radio-button>
                          <!--                        <el-radio-button label="3" style="width: 100%;padding: 10px;">Özel</el-radio-button>-->
                        </el-radio-group>

                        <hr>

                        <div v-if="groupForm.job_select_type == 1">
                          <h5>{{ jobStatusTypes[0].job.title }}</h5>
                          <p style="font-size: 13px;"><span style="font-weight: bold">Dikkat!</span> Bu seçenek ilana
                            başvuran tüm kişileri ekler.</p>
                        </div>
                        <div v-else-if="groupForm.job_select_type == 2">
                          <h5>İlan Sonuç Aşaması Seçiniz</h5>
                          <p style="font-size: 13px;"><span style="font-weight: bold">Dikkat!</span> Bu seçenek sonuç
                            aşamasına eklediğiniz tüm kişileri ekler.</p>
                          <el-form-item prop="jobStatusTypeValue" class="form-control-alternative">
                            <el-select
                                class="w-100 form-control-alternative"
                                v-model="groupForm.jobStatusTypeValue"
                                filterable
                                placeholder="Seçiniz"
                            >
                              <el-option
                                  v-for="(item, index) in groupForm.jobStatusTypes"
                                  :key="index"
                                  :value="item.id"
                                  :label="item.name"
                              ></el-option>
                            </el-select>
                          </el-form-item>

                        </div>
                        <div v-else-if="groupForm.job_select_type == 3">
                          <h5>{{ jobStatusTypes[0].job.title }}</h5>
                          <p style="font-size: 13px;"><span style="font-weight: bold">Dikkat!</span> Bu seçenek ilana
                            başvuran adaylardan seçtiklerinizi mesaj grubuna ekler.</p>
                          <input type="text" class="form-control" ref="searchField" v-model="jobSearchText"
                                 placeholder="Ara" @keyup="searchJobs()"
                                 style="margin: 9px 0px 10px 0px;">
                          <hr>


                        </div>

                        <div v-if="groupForm.job_select_type !== ''">

                          <el-form-item prop="writable" class="form-control-alternative">
                            <el-radio-group v-model="groupForm.writable" size="mini">
                              <el-radio-button label="1" style="width: 100%;padding-top: 12px">Gruba herkes mesaj
                                atabilsin
                              </el-radio-button>
                              <el-radio-button label="0" style="width: 100%;">Gruba sadece yönetici mesaj atabilsin
                              </el-radio-button>
                              <!--                        <el-radio-button label="3" style="width: 100%;padding: 10px;">Özel</el-radio-button>-->
                            </el-radio-group>
                          </el-form-item>

                          <label for="title">Başlık</label>
                          <el-form-item id="title" prop="title" class="form-control-alternative">
                            <el-input class="form-control-alternative" id="title"
                                      placeholder="Grubunuz için bir başlık yazınız"
                                      v-model="groupForm.title"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                    <div style="padding: 10px">
                      <el-button @click="addToMessageGroup('groupForm')" type="primary"
                                 class="btn btn-sm btn-block btn-primary mt-100">Mesaj Grubunu
                        Oluştur
                      </el-button>
                    </div>
                  </div>
                </div>
                <!-- New Message Field and connection search / end  -->
                <!-- Messages / End -->
                <!-- Message Content -->
                <div class="message-content align-items-stretch" style="max-height: 700px;min-height: 700px;">
                  <chat-detail
                      v-if="conversation"
                      :auth="getUserModel"
                      :key="conversation.id"
                      :conversation="conversation"
                      :type="type"
                      @handleMessageActivity="handleMessageActivity"
                      @openNewMessageField="openNewMessageField"
                  ></chat-detail>
                  <div style="height: 100%" v-else>
                    <div class="messages-headline">
                      <h4>Chat Sayfası</h4>
                      <!--                                <a href="#" class="message-action"><i class="icon-feather-trash-2"></i> Delete Conversation</a>-->
                    </div>
                    <!-- Message Content Inner -->
                    <div class="message-content-inner" style="height: 100%">
                      <div class="empty-body">
                        <p style="text-align:center"><i style="font-size: 66px;"
                                                        class="ni ni-chat-round"></i></p>
                        <h3 style="text-align:center;margin-bottom: 15px;color: #888888;">Yeni Grup
                          Oluşturmak İçin Tıklayınız</h3>
                        <div style="text-align:center;">
                          <button class="empty-button" v-on:click="openNewMessageField">Yeni Grup
                            Oluştur
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Message Content Inner / End -->
                  </div>
                </div>
                <!-- Message Content -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as axios from "axios";
import {mapGetters} from "vuex";
import ChatDetail from "@/components/Chat/ChatDetail";
import {getMessagesCount} from "../../services/user-service"
import InfiniteLoading from 'vue-infinite-loading';
import Vue from 'vue'
// import VueEcho from "vue-echo-laravel";

// import Echo from 'laravel-echo'


// Vue.use(VueEcho, {
//   broadcaster: 'socket.io',
//   host: 'https://vizyonergenc.com:6001',
//   // host: 'http://vg.test:6001',
//   // transports: ['websocket'],
//   // authEndpoint : 'http://vg.test/broadcasting/auth',
//   auth: {headers: {Authorization: 'Bearer ' + localStorage.getItem("access_token")}},
//   timeout: 2000
//
// });

Vue.use(InfiniteLoading, {
  slots: {
    noMore: '', // you can pass a string value,
    noResults: '',
  },
});
//
// export var echo_instance = new Echo({
//   broadcaster: 'socket.io',
//   host: 'http://vg.test' + ':6001',
//   // authHost: 'http://vg.test',
//   // authEndpoint:  '/broadcasting/auth',
//   // auth: {
//   //   headers:
//   //       {
//   //         Authorization: 'Bearer ' + localStorage.getItem("access_token")
//   //       }
//   // },
//
// });
//
// Vue.prototype.$echo = echo_instance

import {env} from '@/environments/env';

export default {
  name: "Chat",
  components: {
    ChatDetail,
  },
  computed: {
    ...mapGetters({
      getUserModel: "userModule/getUserModel",
    })
  },
  data() {
    return {
      loading: true,
      connectionLoading: false,
      results: null,
      searchQuery: "",
      newMessageField: false,
      newMessageSearchQuery: "",
      conversations: '',
      conversation: null,
      connections: null,
      type: "conversation",
      conversationsCurrentPage: 2,
      newMessageSearchCurrentPage: 2,
      auth: null,
      jobSearchText: '',
      jobStatusTypeField: false,
      jobsCurrentPage: 2,
      groupForm: {
        jobStatusTypes: '',
        jobStatusTypeValue: '',
        job_select_type: 2,
        title: "",
        message: '',
        jobId: '',
        writable: ''
      },
      rules: {
        title: [
          {
            required: true,
            message: "Lütfen grup başlığını giriniz",
            trigger: "blur",
          },
        ],
        writable: [
          {
            required: true,
            message: "Lütfen bir seçenek seçiniz",
            trigger: "blur",
          },
        ],
        jobStatusTypeValue: [
          {
            required: true,
            message: "Lütfen bir sonuç seçiniz",
            trigger: "blur",
          },
        ],

      },
      chatInterval:null
    };
  },
  mounted() {

    this.loading = true;
    this.getConversations();
    this.bindChannels()
    this.auth = this.getUserModel;

  },
  beforeDestroy() {    // channeldan çıkma işlemi yapıldı
    this.leaveChannels();
  },
  methods: {
    bindChannels(){
      getMessagesCount();
      this.chatInterval = setInterval(this.getConversation, 60*1000);
    },
    leaveChannels() {
      clearInterval(this.chatInterval);
      // window.Echo.leave('App.User.' + this.getUserModel.id);
    },
    conversationDetail(item, type = "conversation", id = '', name = '') {
      this.type = type;
      if (type == "user") {  // eğer tipi user ise mesajları user'a göre getir.
        const data = {
          new_conversation_user_id: id,
          new_message: 1,
          id: id,
          name: name,
        };
        this.conversation = data;
      } else {
        this.conversation = item;
      }
    },
    submitSearch(type) {
      this.loading = true;
      if (this.searchQuery == '') {
        if (type == "chat") { // eğer chat listesi gelicek ise chat kişilerini getir
          this.getConversations();
          return;
        } else {               // tipi arkadaş listesi ise arkadaş listesini çalıştır.
          this.getConnectionList();
          return;
        }
      }
      axios.get('conversations/search-' + type + '?keywords=' + this.searchQuery)
          .then(response => {
            if (type == 'chat') {
              this.conversations = response.data.data;
            } else {
              this.results = response.data.data;
            }
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
    },
    getConversations() {
      axios.get('conversations').then(response => {
        this.loading = false;
        this.conversations = response.data.data;
      }).catch(e => {
        console.log(e);
      });
    },
    handleMessageActivity() {
      this.newMessageField = false;
      this.searchQuery = '';
      this.getConversations();
    },
    // mesaj ekleme kısmını açar ve kişileri getirir
    openNewMessageField() {
      this.loading = true;
      this.newMessageField = true;
      this.jobStatusTypeField = false;
      this.getConnectionList();
    },
    getConnectionList() {
      return axios.get('conversations/jobs/list').then(response => {
        console.log("jobs", response.data)
        this.results = response.data.data;
        this.loading = false;
      })
          // eslint-disable-next-line no-unused-vars
          .catch(err => {
          });
    },

    closeNewMessageBox() {
      this.newMessageField = false;
      this.getConversations();
    },
    conversationsLoadMore($state) {
      setTimeout(() => {
        if (this.conversations !== '' && this.conversations.length > 9) {
          axios.get('conversations?page=' + this.conversationsCurrentPage).then(response => {
            if (response.data.data.length > 0) {
              this.loading = false;
              this.conversations.push(...response.data.data)
              $state.loaded();
              this.conversationsCurrentPage++;
            } else {
              $state.complete();
            }
          }).catch(e => {
            $state.complete();
            console.log(e);
          });
        } else {
          $state.complete();
        }
      }, 1000)

    },
    newMessageSearchLoadMore($state) {
      setTimeout(() => {
        if (this.results !== '' && this.results.length > 9) {
          return axios.get('conversations/friends/list?page=' + this.newMessageSearchCurrentPage).then(response => {
            if (response.data.data.length > 0) {
              this.loading = false;
              this.results.push(...response.data.data)
              $state.loaded();
              this.newMessageSearchCurrentPage++;
            } else {
              $state.complete();
            }
          }).catch(e => {
            $state.complete();
            console.log(e);
          });
        } else {
          $state.complete();
        }
      }, 1000)
    },

    searchJobs() {
      this.loading = true;
      return axios.get('conversations/jobs/list?keywords=' + this.jobSearchText).then(response => {
        console.log("jobs", response.data)
        this.results = response.data.data;
        this.loading = false;
      })
          // eslint-disable-next-line no-unused-vars
          .catch(err => {
          });

    },

    openJobStatusTypeField(job_id) {
      this.groupForm.jobId = job_id;
      this.loading = true;
      this.jobStatusTypeField = true;
      return axios.get('conversations/job-status-type/list/' + job_id).then(response => {
        console.log("status", response.data)
        this.groupForm.jobStatusTypes = response.data;
        this.loading = false;
      })
          // eslint-disable-next-line no-unused-vars
          .catch(err => {
          });
    },
    closeJobStatusTypeField() {
      this.jobStatusTypeField = false;
    },
    changeJobSelection() {
    },
    addToMessageGroup(formName) {
      // e.preventDefault();

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          var data = {
            job_select_type: this.groupForm.job_select_type,
            jobStatusTypeValue: this.groupForm.jobStatusTypeValue,
            jobId: this.groupForm.jobId,
            title: this.groupForm.title,
            message: this.groupForm.message,
            writable: this.groupForm.writable
          }
          axios.post('conversation/group', data).then(response => {
            this.loading = false;
            this.jobStatusTypeField = false;
            this.newMessageField = false;
            this.conversation = response.data;

            // response döndükten sonra datayı temizlemeiz lazım
            this.groupForm = {
              jobStatusTypes: '',
              jobStatusTypeValue: '',
              job_select_type: 2,
              title: "",
              message: '',
              jobId: '',
              writable: ''
            }
          }).catch(err => {
            console.log(err);
            this.loading = false;

          })
        } else {
          this.loading = false;
          return false;
        }
      });

    },
    jobsLoadMore($state) {
      setTimeout(() => {
        if (this.results !== '' && this.results.length > 9) {
          axios.get('conversations/jobs/list?page=' + this.jobsCurrentPage).then(response => {
            if (response.data.data.length > 0) {
              this.loading = false;
              this.results.push(...response.data.data)
              $state.loaded();
              this.jobsCurrentPage++;
            } else {
              $state.complete();
            }
          }).catch(e => {
            $state.complete();
            console.log(e);
          });
        } else {
          $state.complete();
        }
      }, 1000)
    },
    playSound() {
      const url = env.SITE_URL + "sound/message.mp3";
      const audio = new Audio(url);
      audio.muted = false;
      audio.play();
    }
  }
}
</script>

<style>
@import "../../assets/css/chat.css";

.empty-button {
  margin: auto;
  border: 1px solid #0073b5;
  padding: 10px;
  border-radius: 4px;
  color: white;
  background-color: #0073b5;
}

.empty-body {
  height: 75%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#newMessageField {
  max-height: 700px;
  overflow-y: auto;
  min-width: 340px;
}

#messageField {
  max-height: 700px;
  overflow-y: auto;
  min-width: 340px;
}

#jobStatusTypeField {
  max-height: 700px;
  overflow-y: auto;
  min-width: 340px;
}

::-webkit-scrollbar {
  display: none;
}

.unread {

  background-color: #e6e6e691;
}

.read {
  /*background-color: white;*/
}

.active-chat-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background-color: #0073b5;
  display: block;
  transition: 0.3s;

}

.notify-ring {
  position: absolute;
  right: 52px;
  bottom: 48px;
  font-size: 15px;
  background-color: #0073b5;
  color: white;
  border: 1px solid #0073b5;
  border-radius: 50px;
  width: 28px;
  height: 28px;
  text-align: center;
}

.el-radio-button .el-radio-button__inner {
  width: 100%;
}

.el-radio-button__inner {
  border-left: 1px solid #DCDFE6;
}

hr {
  margin-top: 0;
  margin-bottom: 10px;
}

.el-radio-group {
  width: 100%;
}

ul li img {
  object-fit: contain;
}

</style>